import React, { useContext, useEffect, useState } from "react";
import { Box, ChakraProvider, extendTheme, Link, ColorModeScript } from "@chakra-ui/react";
import theme from './theme';
import {
  createBrowserRouter,
  RouterProvider,
  useRouteError,
} from "react-router-dom";
import AuthContext from "./contexts/Auth";
import EmployeList, {
  EmployeLoader,
} from "./routes/Dashboard/Employes/EmployeList/EmployeeList";
import { EmployeeCreate } from "./routes/Dashboard/Employes/EmployeeCreate";
import ServiceList, {
  ServiceLoader,
} from "./routes/Dashboard/Service/ServiceList/ServiceList";
import ServiceListCardView, {
  ServiceLoader as ServiceRecordsLoader,
} from "./routes/Dashboard/Service/ServiceList/ServiceListCardView";
import TestPage from "./routes/TestPage";
import Home from "./routes/Dashboard/HomePage/Home";
import Teams, { Teamsloader } from "./routes/Dashboard/Teams/Team";
import Reseller, {
  ResellerLoader,
} from "./routes/Dashboard/Resellers/ResellerList/ResellerList";
import ResellerDetail, {
  resellerDetailLoader,
} from "./routes/Dashboard/Resellers/ResellerDetail/ResellerDetail";
import Tickets, {
  ticketsLoader,
  completedticketsLoader,
} from "./routes/Dashboard/Ticket/TicketList/TicketList";
import Tasks, { TasksLoader } from "./routes/Dashboard/Task/TaskList/TaskList";
import Appointment from "./routes/Dashboard/Task/TaskList/appointmentLoader.jsx";
import Errorpage from "./routes/Dashboard/404.js";
import Ticket, {
  ticketLoader,
} from "./routes/Dashboard/Ticket/TicketDetail/TicketDetail";
import Account, { profileLoader } from "./routes/Dashboard/Account";
import { TicketCreate } from "./routes/Dashboard/Ticket/TicketCreate";
import Query from "./routes/Public/Support/TicketQuery.jsx";
import LiveSupport from "./routes/Public/LiveSupport/LiveSupport.jsx";
import Login from "./routes/Public/Auth/Login.jsx";
import Forgot from "./routes/Public/Auth/Forgot.jsx";
import Reset from "./routes/Public/Auth/Reset.jsx";
import ServiceFormDownload from "./routes/Public/ServiceFormDownload.jsx";
import Cookies from "js-cookie";
import { ProjectCreate } from "./routes/Dashboard/Project/ProjectCreate/ProjectCreate";
import DashboardLayout from "./components/layouts/Dashboard";
import Customer, {
  CustomerLoader,
} from "./routes/Dashboard/Customers/CustomerList/CustomerList";
import ProjectList, {
  ProjectListLoader,
} from "./routes/Dashboard/Project/ProjectList/ProjectList";
import UnitDetail, {
  unitDetailLoader,
} from "./routes/Dashboard/Project/Unit/UnitDetail/UnitDetail";
import CustomerDetail, {
  customerdetailLoader,
} from "./routes/Dashboard/Customers/CustomerDetail/CustomerDetail";
import Project, {
  projectLoader,
} from "./routes/Dashboard/Project/ProjectDetail/ProjectDetail.jsx";
import TicketsMap from "./routes/Dashboard/Map/TicketsMap";
import EmbeddedFormApp from "./routes/Dashboard/Form/EmbeddedFormApp";
import FormsLite from "./routes/Dashboard/Form/FormsLite";
import FormsFull from "./routes/Dashboard/Form/FormsFull";
import FormsStats from "./routes/Dashboard/Form/FormsStats";
import Technicians from "./routes/Dashboard/Form/Technicians";
import FormsTechStats from "./routes/Dashboard/Form/FormsTechStats";
import ServiceDetail, {
  serviceLoader,
} from "./routes/Dashboard/Service/ServiceDetail/ServiceDetail";
import AdminHome from "./routes/Admin";
import AdminUsers from "./routes/Admin/Users";
import AdminUserDetail from "./routes/Admin/Users/Detail";
import AdminNotes from "./routes/Admin/Notes";
import AdminPlaces from "./routes/Admin/Places";
import AdminUnitsProjects from "./routes/Admin/UnitsProjects";
import AdminProjects from "./routes/Admin/Projects";
import AdminCustomers from "./routes/Admin/Customers";
import AdminResellers from "./routes/Admin/Resellers";
import AdminUnits from "./routes/Admin/Units";
import AdminEmployees from "./routes/Admin/Employees";
import AdminLogs from "./routes/Admin/Logs";
import AdminIssueKinds from "./routes/Admin/IssueKinds";
import AdminRolePages from "./routes/Admin/RolePages";
import RolePagesMatrix from "./routes/Admin/RolePagesMatrix";
import RolePagesList from "./routes/Admin/RolePagesList";
import RequireSuperuser from "./components/RequireSuperuser";

import { AppointmentsLoader } from "./routes/Dashboard/Task/TaskList/TaskListTableView";
const AuthProvider = ({ children }) => {
  const [data, setData] = React.useState(undefined);
  const login = (userData) => {
    Cookies.set("token", userData.token);
    setData(userData);
  };
  const logout = () => {
    localStorage.removeItem("ticketData", null);
    Cookies.remove("token");
    setData(null);
  };

  return (
    <AuthContext.Provider value={{ data, login, logout, setData }}>
      {children}
    </AuthContext.Provider>
  );
};

function ErrorBoundary() {
  let error = useRouteError();
  if (error && error.response?.status === 403) {
    return (
      <Box bg="tomato" w="100%" p={4} color="white">
        <h1>Hata</h1>
        <p>
          Oturumunuz sona ermiş tekrar giriş yapmak için{" "}
          <Link href="/giris/">tıklayın</Link>
        </p>
      </Box>
    );
  }
  return <Errorpage />;
}
/*
function SentryErrorBoundary(){
  <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}></Sentry.ErrorBoundary>;
}

Sentry.init({
  dsn: "https://e4b7ae2c3277477aa867922ad04dcd7a@app.glitchtip.com/6253",
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
});

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
*/

const router = createBrowserRouter([
  {
    children: [
      {
        path: "/",
        element: <DashboardLayout />,
        errorElement: <ErrorBoundary />,
        children: [
          {
            path: "/ana-sayfa/",
            element: <Home />,
          },
          {
            path: "/takımlar/",
            element: <Teams />,
            loader: Teamsloader,
          },
          {
            path: "/musteriler/",
            element: <Customer />,
            loader: CustomerLoader,
          },
          {
            path: "/is-emri/",
            element: <Tickets />,
            loader: ticketsLoader,
          },
          {
            path: "/tamamlanmis-is-emri/",
            element: <Tickets />,
            loader: completedticketsLoader,
          },
          {
            path: "/proje/",
            element: <ProjectList />,
            loader: ProjectListLoader,
          },
          {
            path: "/harita/",
            element: <TicketsMap />,
          },
          {
            path: "/form/",
            element: <EmbeddedFormApp />,
          },
          {
            path: "/formlar/",
            element: <FormsLite />,
          },
          {
            path: "/formlar/yeni",
            element: <FormsFull />,
          },
          {
            path: "/formlar/:id",
            element: <FormsFull />,
          },
          {
            path: "/formlar/:id/duzenle",
            element: <FormsFull />,
          },
          {
            path: "/formlar/istatistik",
            element: <FormsStats />,
          },
          {
            path: "/formlar/teknisyenler",
            element: <Technicians />,
          },
          {
            path: "/formlar/istatistik/teknisyen",
            element: <FormsTechStats />,
          },
          {
            path: "/proje/:projectId",
            element: <Project />,
            loader: projectLoader,
          },
          {
            path: "/gorevler/",
            element: <Tasks />,
            loader: TasksLoader,
          },
          {
            path: "/randevular/",
            element: <Appointment />,
            loader: AppointmentsLoader,
          },
          {
            path: "/admin/",
            element: <RequireSuperuser><AdminHome /></RequireSuperuser>,
          },
          {
            path: "/admin/rol-sayfalari/",
            element: <RequireSuperuser><AdminRolePages /></RequireSuperuser>,
          },
          {
            path: "/admin/rol-matris/",
            element: <RequireSuperuser><RolePagesMatrix /></RequireSuperuser>,
          },
          {
            path: "/admin/rol-listesi/",
            element: <RequireSuperuser><RolePagesList /></RequireSuperuser>,
          },
          {
            path: "/admin/kullanicilar/",
            element: <RequireSuperuser><AdminUsers /></RequireSuperuser>,
          },
          {
            path: "/admin/kullanicilar/:userId/",
            element: <RequireSuperuser><AdminUserDetail /></RequireSuperuser>,
          },
          {
            path: "/admin/notlar/",
            element: <RequireSuperuser><AdminNotes /></RequireSuperuser>,
          },
          {
            path: "/admin/yerlesimler/",
            element: <RequireSuperuser><AdminPlaces /></RequireSuperuser>,
          },
          {
            path: "/admin/projeler/",
            element: <RequireSuperuser><AdminUnitsProjects /></RequireSuperuser>,
          },
          {
            path: "/admin/projeler/liste/",
            element: <RequireSuperuser><AdminProjects /></RequireSuperuser>,
          },
          {
            path: "/admin/uniteler/",
            element: <RequireSuperuser><AdminUnits /></RequireSuperuser>,
          },
          {
            path: "/admin/calisanlar/",
            element: <RequireSuperuser><AdminEmployees /></RequireSuperuser>,
          },
          {
            path: "/admin/musteriler/",
            element: <RequireSuperuser><AdminCustomers /></RequireSuperuser>,
          },
          {
            path: "/admin/bayiler/",
            element: <RequireSuperuser><AdminResellers /></RequireSuperuser>,
          },
          {
            path: "/admin/loglar/",
            element: <RequireSuperuser><AdminLogs /></RequireSuperuser>,
          },
          {
            path: "/admin/is-tipleri/",
            element: <RequireSuperuser><AdminIssueKinds /></RequireSuperuser>,
          },
          {
            path: "/servis/",
            element: <ServiceList />,
            loader: ServiceLoader,
          },
          {
            path: "/servis/kayitlar/",
            element: <ServiceListCardView />,
            loader: ServiceRecordsLoader,
          },
          {
            path: "/calisanlar/",
            element: <EmployeList />,
            loader: EmployeLoader,
          },
          {
            path: "/calisan-ekle/",
            element: <EmployeeCreate />,
            loader: EmployeLoader,
          },
          {
            path: "/servis/:serviceID",
            element: <ServiceDetail />,
            loader: serviceLoader,
          },
          {
            path: "/is-emri/olustur/",
            element: <TicketCreate />,
            loader: ticketsLoader,
          },
          {
            path: "/proje/olustur/",
            element: <ProjectCreate />,
            loader: ticketsLoader,
          },
          {
            path: "/account/",
            element: <Account />,
            loader: profileLoader,
          },
          {
            path: "/bayi/",
            element: <Reseller />,
            loader: ResellerLoader,
          },
          {
            path: "/is-emri/:ticketID",
            element: <Ticket />,
            loader: ticketLoader,
          },
          {
            path: "/unit/:unitID",
            element: <UnitDetail />,
            loader: unitDetailLoader,
          },
          {
            path: "/musteriler/:customerID",
            element: <CustomerDetail />,
            loader: customerdetailLoader,
          },
          {
            path: "/bayi/:resellerID",
            element: <ResellerDetail />,
            loader: resellerDetailLoader,
          },
          {
            path: "/test/",
            element: <TestPage />
          },

        ],
      },
    ],
  },
  {
    path: "/giris/",
    element: <Login />,
  },
  {
    path: "/giris/unuttum/",
    element: <Forgot />,
  },
  {
    path: "/giris/sifirla/",
    element: <Reset />,
  },

  {
    path: "/sorgu/",
    element: <Query />,
  },
  {
    path: "/canli-destek/:ticketID",
    element: <LiveSupport />,
  },
  {
    path: "/servis-formu/:token",
    element: <ServiceFormDownload />,
  },
  {
    path: "*",
    element: <Errorpage />,
  },
]);

async function fetchDataAndNotify(setInitialData) {
  /*
  try {
    const response = await client.get("/tickets/?state=in_queue");
    const data = response.data.results;

    if (setInitialData) {
      localStorage.setItem("ticketData", JSON.stringify(data));
    } else {
      const previousData = JSON.parse(localStorage.getItem("ticketData")) || [];
      const newData = data.filter(
        (newItem) =>
          !previousData.some((prevItem) => prevItem.number === newItem.number)
      );

      if (newData.length > 0) {
        sendNotification(newData);
      }

      localStorage.setItem("ticketData", JSON.stringify(data));
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
    */
}
function addNumberToLocalStorage(newNumber) {
  // localStorage'dan mevcut numaraları al
  let notifiedNumbers = localStorage.getItem("notifiedNumbers");

  // Eğer mevcut numaralar varsa, JSON formatından diziye dönüştür
  if (notifiedNumbers) {
    notifiedNumbers = JSON.parse(notifiedNumbers);
  } else {
    // Eğer mevcut numaralar yoksa boş bir dizi oluştur
    notifiedNumbers = [];
  }

  // Yeni numarayı diziye ekle
  notifiedNumbers.push(newNumber);

  // Güncellenmiş diziyi tekrar JSON formatına çevir ve localStorage'a kaydet
  localStorage.setItem("notifiedNumbers", JSON.stringify(notifiedNumbers));
}

function sendNotification(newData) {
  /*
  newData.forEach((item) => {
    addNumberToLocalStorage(urlToId(item.url));
    const notification = new Notification(`Yeni iş emri: #${item.number}`, {
      body: `${item.full_name} adlı kişiden yeni bir iş emri geldi.`,
    });

    notification.onclick = function () {
      window.location.href = `/is-emri/${urlToId(item.url)}`;
    };
  });
  */
}

// Theme is now imported from separate file

function App() {
  return (
    <>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <ChakraProvider theme={theme}>
        <AuthProvider>
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </AuthProvider>
      </ChakraProvider>
    </>
  );
}

export default App;
